import useAppCanStateExpire from "./useAppCanStateExpire";
import useAppIsActive from "./useAppIsActive";

const app = {
  useCanStateExpire: useAppCanStateExpire,
  useIsActive: useAppIsActive,
};
export default app;
